import { FormSkeleton } from "@/forms-design-system/FormSkeleton";

export const StripeExpressCheckoutSkeleton = () => {
  return <FormSkeleton width="100%" height="44px" variant="rectangular" sx={{ borderRadius: 1 }} />;
};
